import { useState } from 'react';
import './LazyImage.css';

function LazyImage({ src, alt, className, skeletonClassName }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [hasError, setHasError] = useState(false);

    return (
        <div className={`lazy-image-container ${className || ''}`}>
            {!isLoaded && !hasError && (
                <div className={`image-skeleton ${skeletonClassName || ''}`}>
                    <div className="skeleton-shimmer"></div>
                </div>
            )}
            {!hasError && (
                <img
                    src={src}
                    alt={alt}
                    className={`lazy-image ${isLoaded ? 'loaded' : ''} ${className || ''}`}
                    loading="lazy"
                    onLoad={() => setIsLoaded(true)}
                    onError={() => setHasError(true)}
                />
            )}
            {hasError && (
                <div className={`image-error ${skeletonClassName || ''}`}>
                    <span>🎙️</span>
                </div>
            )}
        </div>
    );
}

export default LazyImage;